module.exports = __webpack_public_path__ + "static/media/IMG_3156.afaf7a69.JPG";